<template>
  <el-container
    id="container-originInfo-editor"
    class="is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div
          style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;"
        >
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item :to="{ path: '/originInfo', query:{page:$route.query.frompage || 1} }">產地情報列表 P{{$route.query.frompage || 1}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" :element-loading-text="loadingHint">
        <!-- <form-content :form="form" style="margin-top: 80px;" /> -->

        <el-form label-width="160px" @submit.native.prevent>

        <el-tabs value="common" type="card">
          <el-tab-pane label="通用" name="common">
            <el-form-item label="排序">
              <el-input v-model="form.Sort" type="number" step="1" min="0"></el-input>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>

        <el-tabs v-model="activeLang" type="card">
          <el-tab-pane label="繁中" name="tw">
            <form-content :form="form" form-key="Tw"
              @title-changed="onTitleChanged"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Cn')" label="簡中" name="cn">
            <form-content :form="form" form-key="Cn"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('En')" label="英文" name="en">
            <form-content :form="form" form-key="En"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Jp')" label="日文" name="jp">
            <form-content :form="form" form-key="Jp"/>
          </el-tab-pane>
        </el-tabs>
        </el-form>

        <p class="auto-save-hint">{{autoSaveHint}}</p>
        <p class="url-hint">https://www.syunkaya.com.tw/origin-info/{{form.URLKey}}</p>

        <el-switch
          v-model="form.Tw.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch>

        <el-tooltip v-if="!isEdit" class="item" effect="dark" placement="top-start">
          <div slot="content">商品網址路徑為以下: https://www.syunkaya.com.tw/originInfo/{{form.URLKey}}</div>
          <el-button type="primary" class="btn-set-url" size="mini" @click="showURLEditor">設定網址</el-button>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">一鍵翻譯會自動將繁體中文的內容翻譯成其他語言，<br>並且覆蓋資料!<br><br>包含圖片影片也會覆蓋，包含內容編輯器</div>
          <el-button type="primary" class="btn-translate" size="mini" @click="autoTranslate">一鍵翻譯</el-button>
        </el-tooltip>

        <el-button type="primary" class="btn-upload" size="mini" @click="submit">
          送出
          <i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-main>

      <u-r-l-setting-modal :isShow="isShowUrlSetModal" @close="isShowUrlSetModal = false" :url-key="form.URLKey" @submit="onSetURLKey"/>
    </el-container>
  </el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import FormContent from '@/data/originInfo/view/editor-form.vue'
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import URLSettingModal from '@/data/originInfo/view/url-setting-modal.vue'
import MixinOfTranslation from '@/utils/mixin-translate.vue'
import MixinAutoSave from '@/utils/mixin-autosave.vue' // cacheKey required

export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages, MixinOfTranslation, MixinAutoSave],
  components: {
    LeftMenu,
    TopHeader,
    FormContent,
    URLSettingModal
  },
  data () {
    return {
      oriObj: {},
      form: {
        ProductIDs: null,
        Date: moment().format(),
        IsActive: true,
        Tw: { Products: [], IsActive: true, Date: moment().format(), Images: [] },
        Cn: { Products: [], IsActive: true, Date: moment().format(), Images: [] },
        En: { Products: [], IsActive: true, Date: moment().format(), Images: [] },
        Jp: { Products: [], IsActive: true, Date: moment().format(), Images: [] }
      },
      activeLang: 'tw',
      isLoading: false,
      loadingHint: '',
      // url key
      isShowUrlSetModal: false,
      isURLKeySetManually: false
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createOriginInfo'
    },
    title () {
      return this.isEdit ? this.form.Tw.Title : '新增'
    }
  },
  methods: {
    /* url key 設置 */
    onTitleChanged () {
      if (this.isEdit) return
      if (!this.isURLKeySetManually) {
        this.form.URLKey = this.form.Tw.Title.replace(/\//g, '')
      }
    },
    onSetURLKey (urlKey) {
      this.isURLKeySetManually = true
      this.form.URLKey = urlKey
    },
    showURLEditor () {
      this.isShowUrlSetModal = true
    },
    /* end url key */
    submit () {
      if (!this.validateInput()) {
        return
      }
      if (this.isImageUploading()) {
        return alert('圖片上傳中，請稍後再送出')
      }

      var payload = JSON.parse(JSON.stringify(this.form))
      payload.Sort = parseInt(payload.Sort)

      // 產地商品
      if (payload.ProductIDs)payload.Products = this.$store.state.product.list.filter(o => payload.ProductIDs.includes(o.ID))

      // 產地水果
      for (let key of this.languages) {
        if (payload[key].ProductIDs)payload[key].OriginInfoProducts = this.$store.state.originInfoProduct.list.filter(o => payload[key].ProductIDs.includes(o.ID))

        payload[key].IsActive = !!payload['Tw'].IsActive
        // payload[key].IsActive = !!payload.IsActive
      }

      this.isLoading = true

      this.loadingHint = '正在上傳資料'

      let promise = this.isEdit
        ? this.$services.originInfo.edit(this, payload)
        : this.$services.originInfo.add(this, payload)
      promise
        .then(res => {
          let ok = res && res.data && res.data.status === 'ok'
          if (ok) this.onObjAddedit(res)
        })
        .catch(this.$handleServiceError)
        .finally(() => {
          this.isLoading = false
        })
    },
    isImageUploading () {
      for (let lang of this.languages) {
        // 封面圖片
        // if (this.form[lang]['coverImageBlob@3x'] && this.form[lang]['coverImageBlob@3x'] instanceof Blob) return true
        // if (this.form[lang]['coverImageBlob@2x'] && this.form[lang]['coverImageBlob@2x'] instanceof Blob) return true
        // if (this.form[lang]['coverImageBlob@1x'] && this.form[lang]['coverImageBlob@1x'] instanceof Blob) return true

        // 圖片編輯器
        // for (let i in this.form[lang].contentJsonArr) {
        //   let obj = this.form[lang].contentJsonArr[i]
        //   if (!obj) continue
        //   if (obj.type === 'image' && obj.value.img instanceof Blob) {
        //     return true
        //   }
        // }
      }
      return false
    },
    onObjAddedit (res) {
      this.clearCache()
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.$router.push({ name: 'originInfo-list', query: { page: this.$route.query.frompage || 1 } })
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.originInfo.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.originInfo.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.originInfo.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown originInfo for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.URLKey) {
        errMsg = '請設定網址'
      } else if (!this.form.Tw.Title) {
        errMsg = '請輸入標題(繁中)'
      } else if (!this.form.En.Title) {
        errMsg = '請輸入標題(英文)'
      } else if (!this.form.Jp.Title) {
        errMsg = '請輸入標題(日文)'
      } else if (!this.form.TagID) {
        errMsg = '請選擇商品標籤'
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
        return false
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    // tranlsate
    autoTranslate () {
      this.isLoading = true

      const translateKeys = ['Title', 'Description']
      const syncKeys = ['ProductIDs', 'Date', 'MapImageURL']
      // const contentJsonArr = this.form.Tw.contentJsonArr

      this.syncForm(syncKeys)
      // Images不能直接sync，不然ID會被改掉
      let langs = this.languages.filter(o => o !== 'Tw')
      for (let lang of langs) {
        this.form[lang].Images.forEach(o => { o.DeletedAt = new Date() })
        this.form[lang].Images = this.form.Tw.Images.map(o => {
          let newObject = JSON.parse(JSON.stringify(o))
          newObject.ID = null
          newObject.OwnerID = null
          newObject.OwnerType = null
          return newObject
        })
      }

      let promises1 = this.translateForm(translateKeys)
      // let promises2 = this.translateContentEditor(contentJsonArr)

      // 同步 images
      // let langs = this.languages.filter(o => o !== 'Tw')
      // let arrClone = JSON.parse(JSON.stringify(this.form['Tw']['imagesJsonArr']))
      // for (let lang of langs) {
      //   this.$set(this.form[lang], 'imagesJsonArr', arrClone)
      // }

      Promise.all([promises1]).then(() => {
        this.isLoading = false
      })
    },
    initForm () {
      var formSource = null
      let id = parseInt(this.$route.params.id)
      if (id && id > 0) {
        let idx = this.$store.state.originInfo.list.findIndex(o => o.ID === id)
        if (idx >= 0) {
          this.oriObj = this.$store.state.originInfo.list[idx]
          formSource = JSON.parse(JSON.stringify(this.oriObj))

          formSource.ProductIDs = (formSource.Products || []).map(o => o.ID)
          for (let key of this.languages) {
            formSource[key].ProductIDs = (formSource[key].OriginInfoProducts || []).map(o => o.ID)
          }
          this.form = formSource
        } else {
          console.error(`unknown originInfo for id ${id}`)
        }
      }

      // cache
      this.cacheKey = 'cache-originInfo-' + (this.isEdit ? this.oriObj.ID : 0)
      let cache = this.getCache()
      if (cache) {
        this.confirmLoadCache().then(result => {
          if (result !== 'loaded') return
          let cacheForm = JSON.parse(cache)
          cacheForm.ProductIDs = (cacheForm.Products || []).map(o => o.ID)
          for (let key of this.languages) {
            cacheForm[key].ProductIDs = cacheForm[key].OriginInfoProducts.map(o => o.ID)
          }
          this.form = cacheForm
        }).catch(err => {
          console.error(err)
        })
      }
    }
  },
  created () {
    // 產地有相關的產品，要先preload
    if (
      !this.$store.state.product.isFetched &&
      !this.$store.state.product.isFetching
    ) {
      this.$services.fetchProductDatas(this).then(this.initForm).catch(this.$handleServiceError)
    } else {
      this.initForm()
    }
  }
}
</script>

<style>
.el-tabs {
  height: 100%;
}
.el-tabs .el-tabs__content {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.el-tab-pane {
  max-width: 1030px;
}
</style>
<style scoped>

.btn-translate {
  position: absolute;
  top: 26px;
  right: 110px;
}

.btn-set-url {
  position: absolute;
  top: 26px;
  right: 205px;
}
.switch-deploy {
  position: absolute !important;
  top: 30px;
  right: 300px;
}

.auto-save-hint {
  position: absolute;
  top: 33px;
  right: 424px;
  color: gray;
  font-size: 14px;
}

.url-hint {
  position: absolute;
  top: 0;
  left: 20px;
  color: gray;
  font-size: 14px;
}
</style>
